import { render, staticRenderFns } from "./mobileExchangeMethod.vue?vue&type=template&id=70ae90dc&scoped=true"
import script from "./mobileExchangeMethod.vue?vue&type=script&lang=js"
export * from "./mobileExchangeMethod.vue?vue&type=script&lang=js"
import style0 from "./mobileExchangeMethod.vue?vue&type=style&index=0&id=70ae90dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ae90dc",
  null
  
)

export default component.exports